import FeaturePostSection from './FeaturePost'

export const Blogmain = () => {
  return (
    <>
     <FeaturePostSection />
    </>
  )
}
